import React from 'react';
import styles from './PrevImage.module.scss';
import { Box } from '@mui/material';
import Player from 'react-player';
const PrevImage = ({ form, label, name, radius = '8px' }) => {
  const value = form.watch(name);
  console.log('value', value);

  function isVideoLink(url) {
    const videoExtensions = ['.mp4', '.webm', '.mov', '.avi', '.mkv'];
    return videoExtensions.some((ext) => url.toLowerCase().endsWith(ext));
  }
  return (
    <>
      <Box>
        {label && <Box sx={{ mb: '8px', fontWeight: '600' }}>{label}</Box>}
        {value && isVideoLink(value) ? (
          <Player
            className="Video-full"
            url={value}
            height={'calc(100% - 24px - 8px)'}
            width={'100%'}
            controls={true}
            config={{
              file: {
                forceVideo: true,
              },
            }}
          />
        ) : (
          <Box sx={{ display: 'block', width: '100%', borderRadius: radius, background: 'rgba(0,0,0,0.1)', overflow: 'hidden', objectFit: 'contain', aspectRatio: '1 / 1' }} component={'img'} src={value && value !== 'null' ? value : '/img/image.svg'}></Box>
        )}
      </Box>
    </>
  );
};

export default PrevImage;
